/**
 * Next signals a server-side redirect() by throwing an error carrying a
 * NEXT_REDIRECT digest. That is control flow, not a failure: a catch block
 * around a server action call must re-throw it so the router can complete
 * the navigation instead of showing an error toast on a successful login.
 */
export function isRedirectError(err: unknown): boolean {
  return (
    typeof err === 'object' &&
    err !== null &&
    'digest' in err &&
    typeof err.digest === 'string' &&
    err.digest.startsWith('NEXT_REDIRECT')
  );
}
